<div class="main">
  <div class="plano-alimentar">
    <div class="dados-plano">
      <p
        class="caracteristicas"
        *ngIf="planoSelecionado.caracteristicas?.length"
      >
        {{ planoSelecionado.caracteristicas.join(', ') }}
      </p>
      <p *ngIf="planoSelecionado.condicoesClinicas">
        Condições clínicas específicas: {{planoSelecionado.condicoesClinicas}}
      </p>
      <div class="wrap-datas">
        <img
          alt="calendario"
          src="../../../../assets/svg/icons/calendario.svg"
        />
        <p>
          {{planoSelecionado.periodo.inicio}} a {{planoSelecionado.periodo.fim}}
        </p>
      </div>
    </div>
    <!-- <button *ngIf="modoEdicao" class="adicionar-btn" (click)="abrirModalRefeicoes()">
      <mat-icon class="icon">add</mat-icon>
      Adicionar refeição
    </button> -->
    <button class="adicionar-btn" (click)="abrirModalRefeicoes()">
      <mat-icon class="icon">add</mat-icon>
      Adicionar refeição
    </button>
  </div>
  <div class="container-lista-refeicoes">
    <div class="container-refeicao">
      <div class="titulo">
        <div class="wrap-esquerda">
          <button class="botao" (click)="toggleAgua()">
            <img
              alt="minimizar"
              [src]="containerAguaVisivel ? '../../../../assets/svg/icons/minimizar.svg' : '../../../../assets/svg/icons/maximizar.svg'"
            />
          </button>
          <p>Hidratação</p>
        </div>
      </div>
      <div class="conteudo" *ngIf="containerAguaVisivel">
        <!-- <p class="destaque" *ngIf="modoEdicao">Inserir meta diária de ingestão de água.</p> -->
        <!-- <p class="texto-normal" *ngIf="modoEdicao">Cada copo de água equivale a <strong>200ml.</strong></p> -->

        <p class="destaque">Inserir meta diária de ingestão de água.</p>
        <p class="texto-normal">
          Cada copo de água equivale a <strong>200ml.</strong>
        </p>

        <div class="wrap-input">
          <!-- <mat-form-field appearance="outline" class="compacto" *ngIf="modoEdicao">
            <mat-label>Quantidade (em ml)</mat-label>
            <mat-select [(ngModel)]="planoSelecionado.consumoAguaMl" name="consumoAgua">
              <mat-option *ngFor="let quantidade of quantidadesAgua" [value]="quantidade">
                {{ quantidade }} ml
              </mat-option>
            </mat-select>
          </mat-form-field> -->
          <mat-form-field appearance="outline" class="compacto">
            <mat-label>Quantidade (em ml)</mat-label>
            <mat-select
              [(ngModel)]="planoSelecionado.consumoAguaMl"
              name="consumoAgua"
              (selectionChange)="setDirtyTrue()"
            >
              <mat-option
                *ngFor="let quantidade of quantidadesAgua"
                [value]="quantidade"
              >
                {{ quantidade }} ml
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- <p class="texto-normal" *ngIf="!modoEdicao">Meta diária de ingestão de água diária</p> -->
          <p class="texto-normal">Meta diária de ingestão de água diária</p>

          <p class="destaque-2">
            = {{ planoSelecionado.consumoAguaMl ? planoSelecionado.consumoAguaMl
            / 200 : 0 }} copos
          </p>
        </div>
      </div>
    </div>
    <div
      class="container-refeicao"
      *ngFor="let refeicao of refeicoesSelecionadas"
    >
      <div class="titulo">
        <div class="wrap-esquerda">
          <button class="botao" (click)="toggleRefeicao(refeicao)">
            <img
              alt="minimizar"
              [src]="refeicaoAberta(refeicao) ? '../../../../assets/svg/icons/minimizar.svg' : '../../../../assets/svg/icons/maximizar.svg'"
            />
          </button>
          <p>
            {{ (refeicao.nome === 'Outra' ? refeicao.nomePersonalizado :
            refeicao.nome) + ' - ' + refeicao.horario }}
          </p>
        </div>
        <div class="wrap-direita">
          <button class="botao" (click)="abrirModalObservacoes(refeicao)">
            <img
              alt="observacoes"
              src="../../../../assets/svg/icons/observacoes-refeicao.svg"
            />
          </button>
          <!-- <button *ngIf="modoEdicao" class="botao-2" (click)="removerRefeicao(refeicao)">
            <img alt="excluir" src="../../../../assets/svg/icons/deletar.svg">
          </button> -->
          <button class="botao-2" (click)="removerRefeicao(refeicao)">
            <img alt="excluir" src="../../../../assets/svg/icons/deletar.svg" />
          </button>
        </div>
      </div>
      <div class="lista-opcoes" *ngIf="refeicaoAberta(refeicao)">
        <div
          class="container-opcao"
          *ngFor="let opcao of refeicao.opcoes; trackBy: trackByOpcao"
        >
          <div class="wrap-titulo-opcao">
            <p class="titulo">{{opcao.titulo}}</p>
            <button
              *ngIf="opcao.idOpcao! > 1"
              class="excluir"
              (click)="removerOpcao(refeicao, opcao)"
            >
              <img
                alt="excluir"
                src="../../../../assets/svg/icons/deletar.svg"
              />
            </button>
          </div>

          <button
            class="pesquisar"
            (click)="abrirModalBuscarAlimentos(opcao, refeicao)"
          >
            <img alt="lupa" src="../../../../assets/svg/icons/search.svg" />
            <p class="texto-pesquisar">Buscar e adicionar alimento</p>
          </button>
          <div class="container-alimentos">
            <table>
              <tr class="primeira-linha">
                <td>
                  <img
                    alt="detalhes-alimento"
                    src="../../../../assets/svg/icons/detalhes-alimento.svg"
                  />
                </td>
                <td>Alimentos da refeição</td>
                <td>Total (g)</td>
                <td>Energia (kcal)</td>
                <td>Proteína (g)</td>
                <td>Carboidratos (g)</td>
                <td>Lipídios</td>
                <td></td>
              </tr>
              <tr
                class="linha-detalhes"
                *ngFor="let linha of (alimentosPorRefeicao.get(refeicao.idRefeicao!)?.get(opcao.idOpcao!) || []); trackBy: trackByLinha"
              >
                <td>
                  @if(linha.plano.idTaco > 0) {
                  <button
                    (click)="abrirModalDetalhesAlimentoTaco(linha.plano.idTaco, linha.plano.gramas)"
                  >
                    <img
                      alt="detalhes-alimento"
                      src="../../../../assets/svg/icons/detalhes-alimento.svg"
                    />
                  </button>
                  }
                </td>
                <td>
                  <ng-container *ngIf="linha.editandoNome; else mostraNome">
                    <mat-form-field appearance="outline" class="digitar">
                      <input
                        style="font-size: 14px"
                        matInput
                        type="text"
                        [(ngModel)]="linha.plano.nomePersonalizado"
                        (ngModelChange)="setDirtyTrue()"
                      />
                      <button
                        class="confirmar"
                        matSuffix
                        (click)="confirmarNome(linha)"
                      >
                        <img
                          alt="confirmar"
                          src="../../../../assets/svg/icons/confirmar.svg"
                        />
                      </button>
                    </mat-form-field>
                  </ng-container>
                  <ng-template #mostraNome>
                    {{ linha.plano.nomePersonalizado }}
                    <button
                      class="editar"
                      mat-icon-button
                      (click)="editarNome(linha)"
                    >
                      <img
                        alt="editar"
                        src="../../../../assets/svg/icons/editar.svg"
                      />
                    </button>
                  </ng-template>
                </td>
                <td>
                  <ng-container
                    *ngIf="linha.editandoQuantidade; else mostraQuantidade"
                  >
                    <mat-form-field appearance="outline" class="digitar">
                      <input
                        style="font-size: 14px"
                        matInput
                        type="number"
                        [(ngModel)]="linha.plano.gramas"
                        (ngModelChange)="setDirtyTrue()"
                      />
                      <button
                        class="confirmar"
                        matSuffix
                        (click)="confirmarQuantidade(linha)"
                      >
                        <img
                          alt="confirmar"
                          src="../../../../assets/svg/icons/confirmar.svg"
                        />
                      </button>
                    </mat-form-field>
                  </ng-container>
                  <ng-template #mostraQuantidade>
                    {{ formatarNumero(linha.plano.gramas) }}
                    <button
                      class="editar"
                      mat-icon-button
                      (click)="editarQuantidade(linha)"
                    >
                      <img
                        alt="editar"
                        src="../../../../assets/svg/icons/editar.svg"
                      />
                    </button>
                  </ng-template>
                </td>

                <!-- Valor Energético (kcal) -->
                <td>
                  <!-- Se for alimento TACO -->
                  @if (linha.plano.idTaco > 0) { {{ getValorNutriente(linha,
                  'energiaKcal') | number:'1.0-0' }} }

                  <!-- Se for alimento personalizado -->
                  @else {
                  <ng-container
                    *ngIf="linha.editandoKcalorias; else mostraKcalorias"
                  >
                    <mat-form-field appearance="outline" class="digitar">
                      <input
                        style="font-size: 14px"
                        matInput
                        type="number"
                        [(ngModel)]="linha.plano.kcaloriasPersonalizado"
                        (ngModelChange)="setDirtyTrue()"
                      />
                      <button
                        class="confirmar"
                        matSuffix
                        (click)="confirmarKcalorias(linha)"
                      >
                        <img
                          alt="confirmar"
                          src="../../../../assets/svg/icons/confirmar.svg"
                        />
                      </button>
                    </mat-form-field>
                  </ng-container>
                  <ng-template #mostraKcalorias>
                    {{ formatarNumero(linha.plano.kcaloriasPersonalizado) }}
                    <button
                      class="editar"
                      mat-icon-button
                      (click)="editarKcalorias(linha)"
                    >
                      <img
                        alt="editar"
                        src="../../../../assets/svg/icons/editar.svg"
                      />
                    </button>
                  </ng-template>
                  }
                </td>

                <!-- Proteinas -->
                <td>
                  <!-- Se for alimento TACO -->
                  @if (linha.plano.idTaco > 0) { {{ getValorNutriente(linha,
                  'proteinaG') | number:'1.1-1' }} }

                  <!-- Se for alimento personalizado -->
                  @else {
                  <ng-container
                    *ngIf="linha.editandoProteinas; else mostraProteinas"
                  >
                    <mat-form-field appearance="outline" class="digitar">
                      <input
                        style="font-size: 14px"
                        matInput
                        type="number"
                        [(ngModel)]="linha.plano.proteinasPersonalizado"
                        (ngModelChange)="setDirtyTrue()"
                      />
                      <button
                        class="confirmar"
                        matSuffix
                        (click)="confirmarProteinas(linha)"
                      >
                        <img
                          alt="confirmar"
                          src="../../../../assets/svg/icons/confirmar.svg"
                        />
                      </button>
                    </mat-form-field>
                  </ng-container>
                  <ng-template #mostraProteinas>
                    {{ formatarNumero(linha.plano.proteinasPersonalizado) }}
                    <button
                      class="editar"
                      mat-icon-button
                      (click)="editarProteinas(linha)"
                    >
                      <img
                        alt="editar"
                        src="../../../../assets/svg/icons/editar.svg"
                      />
                    </button>
                  </ng-template>
                  }
                </td>

                <!-- Carboidratos -->
                <td>
                  <!-- Se for alimento TACO -->
                  @if (linha.plano.idTaco > 0) { {{ getValorNutriente(linha,
                  'carboidratoG') | number:'1.1-1'}} }

                  <!-- Se for alimento personalizado -->
                  @else {
                  <ng-container
                    *ngIf="linha.editandoCarboidratos; else mostraCarboidratos"
                  >
                    <mat-form-field appearance="outline" class="digitar">
                      <input
                        style="font-size: 14px"
                        matInput
                        type="number"
                        [(ngModel)]="linha.plano.carboidratosPersonalizado"
                        (ngModelChange)="setDirtyTrue()"
                      />
                      <button
                        class="confirmar"
                        matSuffix
                        (click)="confirmarCarboidratos(linha)"
                      >
                        <img
                          alt="confirmar"
                          src="../../../../assets/svg/icons/confirmar.svg"
                        />
                      </button>
                    </mat-form-field>
                  </ng-container>
                  <ng-template #mostraCarboidratos>
                    {{ formatarNumero(linha.plano.carboidratosPersonalizado) }}
                    <button
                      class="editar"
                      mat-icon-button
                      (click)="editarCarboidratos(linha)"
                    >
                      <img
                        alt="editar"
                        src="../../../../assets/svg/icons/editar.svg"
                      />
                    </button>
                  </ng-template>
                  }
                </td>

                <!-- Lipídios -->
                <td>
                  <!-- Se for alimento TACO -->
                  @if (linha.plano.idTaco > 0) { {{ getValorNutriente(linha,
                  'lipidiosG') | number:'1.1-1' }} }

                  <!-- Se for alimento personalizado -->
                  @else {
                  <ng-container
                    *ngIf="linha.editandoLipidios; else mostraLipidios"
                  >
                    <mat-form-field appearance="outline" class="digitar">
                      <input
                        style="font-size: 14px"
                        matInput
                        type="number"
                        [(ngModel)]="linha.plano.lipidiosPersonalizado"
                        (ngModelChange)="setDirtyTrue()"
                      />
                      <button
                        class="confirmar"
                        matSuffix
                        (click)="confirmarLipidios(linha)"
                      >
                        <img
                          alt="confirmar"
                          src="../../../../assets/svg/icons/confirmar.svg"
                        />
                      </button>
                    </mat-form-field>
                  </ng-container>
                  <ng-template #mostraLipidios>
                    {{ formatarNumero(linha.plano.lipidiosPersonalizado) }}
                    <button
                      class="editar"
                      mat-icon-button
                      (click)="editarLipidios(linha)"
                    >
                      <img
                        alt="editar"
                        src="../../../../assets/svg/icons/editar.svg"
                      />
                    </button>
                  </ng-template>
                  }
                </td>

                <td>
                  <button
                    class="excluir"
                    (click)="removerAlimento(linha, refeicao)"
                  >
                    <img
                      alt="excluir"
                      src="../../../../assets/svg/icons/deletar.svg"
                    />
                  </button>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="container-adicionar">
          <button class="adicionar-opcao" (click)="adicionarOpcao(refeicao)">
            <mat-icon class="icon">add</mat-icon> Adicionar outra opção
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="container-botoes-finais" *ngIf="refeicoesSelecionadas.length > 0">
    <button class="sair-btn" (click)="sairSemSalvar()">Sair sem salvar</button>
    <button
      *ngIf="!modoEdicao"
      class="rascunho-btn"
      [disabled]="!planoValido()"
      (click)="salvarRascunho()"
    >
      Salvar como rascunho
    </button>
    <button
      *ngIf="!modoEdicao"
      class="salvar-btn"
      (click)="salvarPlano()"
      [disabled]="!planoValido()"
    >
      Ativar plano alimentar no app
    </button>
    <button
      *ngIf="modoEdicao"
      class="salvar-btn"
      (click)="salvarPlano()"
      [disabled]="!planoValido() || !planoAlterado()"
    >
      Salvar alterações
    </button>
  </div>

  <!-- <div class="container-botoes-finais" *ngIf="!modoEdicao">
    <button class="salvar-btn" (click)="voltarAoComponentePai()">
      Voltar
    </button>
  </div> -->
</div>
